import _ from 'lodash';

export const resTransform = {
  fetchList(resData) {
    return (_.isArray(resData) ? resData : []).map((details) => resTransform.fetchDetails(details));
  },
  fetchDetails(resData) {
    return {
      biofuelcircle_master_id: _.get(resData, 'biofuelcircle_master_id') || 0,
      circle_name: _.get(resData, 'circle_name') || '',
      circle_code: _.get(resData, 'circle_code') || '',
    };
  },
};
